var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_x_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.5 46.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_x_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_x_svg__cls-1",
    d: "M8.58 8.58h29.34v29.34H8.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_x_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_x_svg__cls-1",
    d: "M0 0h46.5v46.5H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".icon_x_svg__cls-1{stroke-width:0;fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_x_svg__clippath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.34 21.42l8.08-9.58h-1.74l-7.11 8.46-5.75-8.46H12.1l8.79 12.82-8.39 9.99h1.74l7.44-8.85 6.07 8.85h6.61l-9.04-13.23zm-10.37-8.07h3.05l13.51 19.79h-3L14.97 13.35z",
    fill: "#0088ac",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_x_svg__clippath-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 45.65c12.35 0 22.4-10.05 22.4-22.4S35.6.85 23.25.85.85 10.9.85 23.25s10.05 22.4 22.4 22.4z",
    stroke: "#0085a1",
    strokeWidth: 1.7,
    fill: "none"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNDYuNSA0Ni41Ij48ZGVmcz48c3R5bGU+LmNscy0xLC5jbHMtMntzdHJva2Utd2lkdGg6MHB4O30uY2xzLTEsLmNscy0ze2ZpbGw6bm9uZTt9LmNscy00e2NsaXAtcGF0aDp1cmwoI2NsaXBwYXRoLTEpO30uY2xzLTJ7ZmlsbDojMDA4OGFjO30uY2xzLTV7Y2xpcC1wYXRoOnVybCgjY2xpcHBhdGgpO30uY2xzLTN7c3Ryb2tlOiMwMDg1YTE7c3Ryb2tlLXdpZHRoOjEuN3B4O308L3N0eWxlPjxjbGlwUGF0aCBpZD0iY2xpcHBhdGgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iOC41OCIgeT0iOC41OCIgd2lkdGg9IjI5LjM0IiBoZWlnaHQ9IjI5LjM0Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImNsaXBwYXRoLTEiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQ2LjUiIGhlaWdodD0iNDYuNSIvPjwvY2xpcFBhdGg+PC9kZWZzPjxnIGNsYXNzPSJjbHMtNSI+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjUuMzQsMjEuNDJsOC4wOC05LjU4aC0xLjc0bC03LjExLDguNDYtNS43NS04LjQ2aC02LjcybDguNzksMTIuODItOC4zOSw5Ljk5aDEuNzRsNy40NC04Ljg1LDYuMDcsOC44NWg2LjYxbC05LjA0LTEzLjIzWk0xNC45NywxMy4zNWgzLjA1bDEzLjUxLDE5Ljc5aC0zTDE0Ljk3LDEzLjM1WiIvPjwvZz48ZyBjbGFzcz0iY2xzLTQiPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIzLjI1LDQ1LjY1YzEyLjM1LDAsMjIuNC0xMC4wNSwyMi40LTIyLjRTMzUuNi44NSwyMy4yNS44NS44NSwxMC45Ljg1LDIzLjI1czEwLjA1LDIyLjQsMjIuNCwyMi40WiIvPjwvZz48L3N2Zz4=";
export { SvgIconX as ReactComponent };